import * as React from "react";

import "./pagination.scss";
import {xdQAattribute}      from "../../analytics-layout";

export const Pagination = ({rows, displayedCount, setDisplayedCount, pageIndex, setPageIndex, pageSizes}) => {
    const pageIndices = []
    for(let i = 0; i < Math.ceil(rows.length / displayedCount); i++) {
        pageIndices.push(i)
    }

    const canDecrementPage = pageIndex > 0
    const canIncrementPage = rows?.length > (pageIndex + 1) * displayedCount
    const showDecrementDash = pageIndex > 1
    const showIncrementDash = pageIndex < pageIndices.length - 2
    const showFirstPage = pageIndex !== 0
    const showLastPage = pageIndex !== pageIndices.length - 1
    const showPaginationControls = canDecrementPage || canIncrementPage

    return (
        <>
            {
                rows.length > pageSizes[0] &&
                <div className="pagination-dznts1">
                    <select 
                        className="page-count"
                        defaultValue={`${pageSizes[0]}`}
                        onChange={(e) => {
                            setDisplayedCount(parseInt(e.target.value))
                            setPageIndex(0)
                        }}
                        {...xdQAattribute('dropdown', 'leads per page')}
                    >
                        {
                            pageSizes.map(size => {
                                return (
                                    <option 
                                        key={size} 
                                        value={size}
                                        {...xdQAattribute('dropdown_item', `${size} per page`)}
                                    >
                                        {size}
                                    </option>
                                )
                            })
                        }
                    </select>
                    {
                        showPaginationControls &&
                        <div className="controls">
                            <button 
                                className={`page-select decrement${canDecrementPage ? '' : ' disallowed'}`}
                                onClick={() => {
                                    if(!canDecrementPage) {
                                        return
                                    }
                                    setPageIndex(pageIndex - 1)
                                }}
                                {...xdQAattribute('button', 'previous page')}
                            >
                                <i className="fa fa-angle-left" />
                            </button>
                                
                            {
                                showFirstPage && 
                                <button
                                    className='page-select'
                                    onClick={() => {
                                        setPageIndex(0)
                                    }}
                                    {...xdQAattribute('button', 'page 1')}
                                >
                                    1
                                </button>
                            }
                            {
                                showDecrementDash &&
                                <button
                                    className='page-select'
                                    onClick={() => {
                                        if(!canDecrementPage) {
                                            return
                                        }
                                        setPageIndex(pageIndex - 1)
                                    }}
                                >
                                    -
                                </button>
                            }
                           
                            <button
                                className='page-select active'
                                onClick={() => {
                                    return
                                }}
                                {...xdQAattribute('button', `page ${pageIndex + 1}`)}
                            >
                                {pageIndex + 1}
                            </button>

                            {
                                showIncrementDash && 
                                <button
                                    className='page-select'
                                    onClick={() => {
                                        if(!canIncrementPage) {
                                            return
                                        }
                                        setPageIndex(pageIndex + 1)
                                    }}
                                >
                                    -
                                </button>
                            }
                            {
                                showLastPage &&
                                <button
                                    className='page-select'
                                    onClick={() => {
                                        setPageIndex(pageIndices.length - 1)
                                    }}
                                    {...xdQAattribute('button', `page ${pageIndices.length - 1}`)}
                                >
                                    {pageIndices.length}
                                </button>
                            }
                            <button 
                                className={`page-select increment${canIncrementPage ? '' : ' disallowed'}`}
                                onClick={() => {
                                    if(!canIncrementPage) {
                                        return
                                    }
                                    setPageIndex(pageIndex + 1)
                                }}
                                {...xdQAattribute('button', 'next page')}
                            >
                                <i className="fa fa-angle-right" />
                            </button>
                        </div>
                    }
                    <div 
                        className="page-display"
                        {...xdQAattribute('text', 'page-summary')}
                    >
                        {`${pageIndex + 1} of ${pageIndices.length}`}
                    </div>
                </div>
            }
        </>
    )
}